import axios from "axios";
import { config } from "../../configs/axios";
import { adminConfig } from "../../configs/adminAxios";

/* Create a new axios instance | khaled Mofeed | 12/12/2022 */
const axiosInstance = axios.create(config);

export const adminAxiosInstance = axios.create(adminConfig);

// Interceptor to always use the latest admin token from localStorage
adminAxiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin-token") || "";
    if (token) {
      config.headers.Authorization = token.includes("Bearer")
        ? token
        : `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor to always use the latest token from localStorage
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("UserToken") || localStorage.getItem("token") || "";
    if (token) {
      config.headers.Authorization = token.includes("Bearer")
        ? token
        : `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const request = (method, url, payload = {}) => {
  return axiosInstance[method](url, payload);
};
export default axiosInstance;
